<template>
  <b-container
    :class="{
      'modal-bp': true,
      small: isSmall,
    }"
  >
    <div id="modal-content" class="modal-content">
      <div class="modal-top">
        <div class="close-icons">
          <div
            class="close-icon close-r"
            @click="closeFunction ? closeFunction() : null"
          />
        </div>
        <h4 v-if="title">{{ title }}</h4>
      </div>
      <slot name="primary-content" class="modal-primary"> </slot>
      <div class="bottom-container">
        <header>
          <slot name="bottom-content"></slot>
        </header>
      </div>
    </div>
  </b-container>
</template>


<script>
export default {
  name: "modal",
  props: {
    isSmall: {
      type: Boolean,
      required: false,
    },
    closeFunction: {
      type: Function,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.89);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .modal-bp {
    @media (max-width: $lg) {
      max-width: 100vw;
      margin: 0;
      width: 100%;
    }
    @media (max-width: $md) {
      padding: 0;
    }
  }
  .small {
    width: 500px;
  }
  .standalone-text-box {
    overflow-y: scroll;
    padding: 30px;
    width: 900px;
  }
  .overlay-desc {
    max-width: 100%;
    padding-top: 30px;
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
    background-color: $lt-bg-color;
    border-radius: 11px;
    padding: 22px;
    max-width: 95%;
    @media (max-width: $md) {
      width: 100%;
    }
    p {
      max-width: 100%;
    }
  }
  .bottom-container {
    height: 55px;
    background: $lt-modal-window-top;
    width: 100%;
    padding-right: 18px;
    padding-bottom: 14px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .text-info {
    height: 32px;
    width: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-height: 26px;
      max-width: 26px;
      filter: $lt-secondary-color;
    }
  }
  p {
    padding: 30px;
    font-family: $font-primary;
    font-size: 18px;
    color: #000;
    max-width: 100%;
    word-break: break-word;
    @media (max-width: $md) {
      padding: 4px;
    }
  }
  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #ffffff;
    box-shadow: 0 6px 20px 10px rgba(0, 0, 0, 0.1);
    border-radius: 22px;
    overflow: hidden;
    min-height: 25vh;
    max-height: 90vh;
  }
  .modal-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: $lt-modal-window-top;
    width: 100%;
    height: 54px;
    min-height: 54px;
    position: relative;
    padding: 0 100px;
    overflow: hidden;

    h4 {
      font-family: $font-header;
      font-size: 24px;
      color: $lt-dark-gray;
      text-transform: capitalize;
    }
    // transform: translateY(-100%);
  }
  .close-icons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 48px;
    transform: translate(-50%, -50%);
  }
  .close-icon {
    cursor: pointer;
    height: 19px;
    width: 19px;
    border-radius: 50%;
    margin-right: 9px;
  }

  .close-r {
    background: $red-close;
  }
  .close-y {
    background: $yellow-close;
  }
  .close-g {
    background: $green-close;
  }
}
.modal-primary {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  div {
    max-width: 100%;
    width: 100%;
  }
}

.dyn-options {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
@media (max-height: $md) {
  .dyn-options {
    flex-direction: row !important;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
.options {
  padding: 25px;
  margin-bottom: 12px;
  margin-right: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
  max-width: 100%;

  @media (max-height: $md) {
    padding: 7px;
  }
  span,
  img,
  svg {
    margin-right: 10px;
    font-size: 18px;
    font-family: $font-primary;
    &:last-child {
      margin-right: 0;
    }
  }

  svg,
  img {
    height: 30px;
    width: auto;
  }
  .dark-icon {
    height: 15px;
  }
  .light-icon {
    height: 25px;
  }
}
.activeColor {
  color: $lt-secondary-color;
}
</style>
<style lang="scss">
.modal-container {
  *:focus {
    outline: 0;
    outline: none;
  }
  .hooper-slide {
    // height: max-content !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: max-content;
  }
  .hooper-track {
    height: max-content;
    max-height: 100vh;
  }
  .hooper-list {
    height: max-content;
  }
  .hooper {
    height: max-content;
  }
  .hooper-track {
    // height: 800px !important;
    // max-height: 85vh!important;
    display: flex;
    align-items: center;
  }
}
</style>



<style lang="scss" >
.dark {
  .modal-container {
    background: rgba(0, 0, 0, 0.89) !important;
    .options {
      transition: background-color 0.25s ease-in;
    }
    .text-overlay {
      background-color: $dt-bg-color;
    }
    .bottom-container {
      background: $dt-modal-window-top;
    }
    .modal-content {
      background: $dt-bg-color;
      box-shadow: 0 6px 20px 10px rgba(0, 0, 0, 0.1);
    }
    .options {
      span {
        color: rgb(117, 117, 117);
      }
    }
    p {
      color: $dt-font-color;
    }

    .modal-top {
      background: $dt-modal-window-top;

      h4 {
        color: $dt-font-color;
      }
    }
  }
  svg {
    path {
      fill: $dt-secondary-color !important;
    }
  }
}
</style>
